<template>
    <div>

    </div>
</template>
<script>
export default {
  props:{
    name:{
      type:String,
    },
    path:{
      type:String,
    },
  },
  created(){
    if(this.name){
      this.$router.push({name:this.name})      
    }
    if(this.path){
      this.$router.push({path:this.path})
    }
    
  }
}
</script>